import { EmaQuestionnaireSchema, InitialQuestionnaireSchema } from './entity';
import { z } from 'zod';

export const CreateEmaQuestionnaireSchema = EmaQuestionnaireSchema.omit({
  id: true,
  createdAt: true,
});

export const CreateInitialQuestionnaireSchema = InitialQuestionnaireSchema.omit(
  {
    id: true,
    createdAt: true,
  },
);

export const CreateQuestionnaireSchema = z.discriminatedUnion('kind', [
  CreateInitialQuestionnaireSchema,
  CreateEmaQuestionnaireSchema,
]);

export const UpdateEmaQuestionnaireSchema = EmaQuestionnaireSchema.omit({
  id: true,
  createdAt: true,
});

export const UpdateInitialQuestionnaireSchema = InitialQuestionnaireSchema.omit(
  {
    id: true,
    createdAt: true,
  },
);

export const UpdateQuestionnaireSchema = z.discriminatedUnion('kind', [
  UpdateInitialQuestionnaireSchema,
  UpdateEmaQuestionnaireSchema,
]);

export type CreateQuestionnaire = z.infer<typeof CreateQuestionnaireSchema>;
export type UpdateQuestionnaire = z.infer<typeof UpdateQuestionnaireSchema>;

export type CreateEmaQuestionnaire = z.infer<
  typeof CreateEmaQuestionnaireSchema
>;
export type CreateInitialQuestionnaire = z.infer<
  typeof CreateInitialQuestionnaireSchema
>;

export type UpdateEmaQuestionnaire = z.infer<
  typeof UpdateEmaQuestionnaireSchema
>;
export type UpdateInitialQuestionnaire = z.infer<
  typeof UpdateInitialQuestionnaireSchema
>;
